import EmptyList from '@components/EmptyList'
import useWallet from '@plug-core/hooks/useWallet'
import { Permission } from '@plug-core/interfaces/permissions'
import { initializeMessenger } from '@plug-core/messengers'
import { usePermissions } from '@plug-core/state'
import { Avatar, Button, Dialog, IconButton, ListGroup, ListRow } from '@ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TfiUnlink } from 'react-icons/tfi'

const messenger = initializeMessenger({ connect: 'background' })

const ConnectedApps = () => {
  const { permissions } = usePermissions()
  const { wallet } = useWallet()
  const [permissionInEdit, setPermissionInEdit] = useState<Permission>()
  const { t } = useTranslation()

  const principalPermissions = Object.values(permissions[wallet.principalId] || {})

  if (principalPermissions.length === 0)
    return (
      <EmptyList
        title={t('connectedApps.emptyTitle')}
        description={t('connectedApps.emptyDescription')}
      />
    )

  const terminateSession = () => {
    messenger.send('session-terminate', {
      principal: wallet.principalId,
      host: permissionInEdit!.host,
    })

    setPermissionInEdit(undefined)
  }

  return (
    <div className="mb-3 flex flex-1 flex-col gap-2">
      <ListGroup>
        {Object.values(principalPermissions).map((permission, index) => (
          <ListRow
            key={index}
            leading={<Avatar src={permission.logo} fallback={permission.name} size={40} />}
            primary={permission.name}
            secondary={permission.host}
            trailing={
              <IconButton
                aria-label="Disconnect"
                variant="danger"
                size="sm"
                onClick={() => setPermissionInEdit(permission)}
              >
                <TfiUnlink />
              </IconButton>
            }
          />
        ))}
      </ListGroup>

      <Dialog
        open={!!permissionInEdit}
        onClose={() => setPermissionInEdit(undefined)}
        title="Close dApp session"
        description={`Are you sure you want to disconnect from ${permissionInEdit?.name}`}
        actions={
          <>
            <Button variant="danger" onClick={terminateSession} fullWidth>
              Disconnect
            </Button>
            <Button variant="ghost" onClick={() => setPermissionInEdit(undefined)} fullWidth>
              Cancel
            </Button>
          </>
        }
      />
    </div>
  )
}

export default ConnectedApps
